module.exports = __webpack_public_path__ + "img/colorcinch-dark-300x118.823b03bf.png";